import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [RouterLink, FormsModule],
    templateUrl: './login.html',
    styleUrl: './login.css',
})
export class Login {
    private authService = inject(AuthService);

    loading = this.authService.loading;
    error = this.authService.error;

    formData = {
        email: '',
        password: '',
    };

    loginWithGoogle() {
        this.authService.loginWithGoogle();
    }

    async onSubmit() {
        if (!this.formData.email || !this.formData.password) {
            return;
        }

        try {
            await this.authService.loginWithEmail(this.formData.email, this.formData.password);
        } catch (err) {
            // Error is handled in the service
        }
    }

    // Other providers temporarily disabled
    // loginWithGithub() {
    //   this.authService.loginWithGithub();
    // }

    // loginWithAmazon() {
    //   this.authService.loginWithAmazon();
    // }

    // loginWithMicrosoft() {
    //   this.authService.loginWithMicrosoft();
    // }

    clearError() {
        this.authService.clearError();
    }
}
